export { AnimationStyles, AnimationVariables } from './AnimationStyles';
export { DefaultPalette } from './DefaultPalette';
export { DefaultEffects } from './DefaultEffects';
export { DefaultFontStyles, registerDefaultFontFaces } from './DefaultFontStyles';
export { FontSizes, FontWeights, IconFontSizes, createFontStyles } from './fonts';
export * from './getFocusStyle';
export { hiddenContentStyle } from './hiddenContentStyle';
export { PulsingBeaconAnimationStyles } from './PulsingBeaconAnimationStyles';
export { getGlobalClassNames } from './getGlobalClassNames';
export * from './scheme';
export { ThemeSettingName, getTheme, loadTheme, createTheme, registerOnThemeChangeCallback, removeOnThemeChangeCallback, } from './theme';
export * from './CommonStyles';
export * from './GeneralStyles';
export * from './getFadedOverflowStyle';
export * from './getPlaceholderStyles';
export * from './zIndexes';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@uifabric/styling/lib/styles/index.js
// module id = 118
// module chunks = 0